import { useQuery } from 'react-query'
import axios from 'axios'
import { serializeQuery } from './utils'

const ENDPOINT = `/api/store-locator`
const QUERY_KEY = 'store-locator'

export const useGetLocationByPostCode = (query) =>
  useQuery(
    [QUERY_KEY, 'detail', 'geocode', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/geocode`, query)))?.data,
    { enabled: query !== null }
  )
